module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"return":"عودت","Trading transactions":"تراکنش های معاملات","Order transactions from us":"تراکنش های سفارش از ما","Bank deposits and withdrawals":"واریز و برداشت بانکی","all transactions":"همه تراکنش ها","Referral transactions":"تراکنش های رفرال یا بازاریابی"}}')
  delete Component.options._Ctor
}
